// What several screens share: the helpers (dates, natures, scenarios, rights),
// the shared components, the page for an unknown route.
export default {
  pourcent: '{n}%',
  natures: {
    film: 'film',
    serie: 'series',
    article: 'article',
    produit: 'product',
    evenement: 'event',
    polemique: 'controversy',
    autre: 'other',
    inconnu: 'unknown type',
    scrutin: 'election',
    sortie: 'release',
    decision: 'decision',
    finale: 'final',
  },
  scenarios: {
    phrase: '{bas} ~ {haut}',
  },
  // The studio's windows (`EFenetre`, `EEtapes`, `EPiedFenetre`, October 15, 2026).
  fenetre: {
    fermer: 'Close',
    annuler: 'Cancel',
    etapes: 'Steps',
    n: 'Step {n} of {total}',
    suivant: 'Next',
    precedent: 'Back',
  },
  avis: {
    voirPlus: 'See more',
    voirMoins: 'See less',
    // Plain text, no quotes (a sentiment's “why”, October 15, 2026).
    texte: '{texte}',
  },
  droits: {
    role: 'Your role ({role}) does not allow this action: {requis} role required.',
    roleInconnu: 'unknown',
    module: 'Missing permission: {modules}. Ask an administrator for it.',
    ou: 'or',
  },
  job: {
    enAttente: 'waiting',
    echec: 'failed with no message',
  },
  confiance: {
    faible: 'Low confidence',
    moyenne: 'Medium confidence',
    forte: 'High confidence',
  },
  carteDuMonde: 'World map',
  preversion: {
    titre: 'Preview',
    texte: 'simulated data, for illustration only. The backend for this screen arrives in a later phase.',
  },
  introuvable: {
    titre: 'This screen does not exist',
    route: 'No route matches {chemin}.',
    retour: 'Back to home',
  },
  demographie: {
    titre: 'Who responded',
    isos: '{n} twins | {n} twin | {n} twins',
    ageMedian: '· median age {age}',
    aucuneSortie: 'No outings recorded in this window.',
    agesExacts: 'Exact ages',
    etendue: '{min} → {max} years · {n} distinct ages | {min} → {max} years · {n} distinct age | {min} → {max} years · {n} distinct ages',
    barreAge: 'Age {age}: {isos}',
    mediane: 'median {age}',
    axes: {
      ages: 'Age',
      genre: 'Gender',
      csp: 'Occupation',
      segments: 'Segments',
    },
    documente: '{n}% documented',
    nonDocumente: 'Not documented in the territory synthesis: nothing is guessed here.',
    documentePour: 'Documented for {nombre} twins out of {total}. | Documented for {nombre} twin out of {total}. | Documented for {nombre} twins out of {total}.',
    tropPeu: 'Too few for a breakdown: it would show a precise-looking figure drawn from a handful of responses.',
    genres: {
      femme: 'Women',
      homme: 'Men',
      non_binaire: 'Non-binary',
    },
    ecartTitre: 'Deviation from the intended composition',
    ecartSousTitre: '- the shares the synthesis prescribes, against who actually went out',
    ecartSansPart: 'The synthesis documents no share for this segment: there is nothing to compare',
    ecartBruit: 'Over {n} outings, this gap is within sampling noise: no conclusion can be drawn. | Over {n} outing, this gap is within sampling noise: no conclusion can be drawn. | Over {n} outings, this gap is within sampling noise: no conclusion can be drawn.',
  },
  supervision: {
    carteAria: 'World map: {veille} territories on standby, {patrouille} on patrol',
    paysPatrouille: '{nom}: on patrol',
    paysVeille: '{nom}: on standby',
    paysHors: '{nom}: not catalogued',
    continents: {
      ameriqueNord: 'North America',
      ameriqueSud: 'South America',
      europe: 'Europe',
      afrique: 'Africa',
      asie: 'Asia',
      oceanie: 'Oceania',
    },
    titre: 'supervision · territories',
    jourObserve: 'observed day {jour}',
    session: 'session',
    recus: 'received',
    attendusVides: '{attendus} pending · {vides} empty',
    heureAudienceAide: 'Each territory goes out at ITS audience’s time, not at server time.',
    heureAudience: 'audience time',
    eclaireurs: 'scouts',
    satures: 'saturated ≥ {seuil}%',
    surRecus: '/ {n} received',
    sujetsNeufs: 'new topics',
    sur: 'across {n}',
    divergences: 'divergences D+{n}',
    max: 'max D+{n}',
    sansClicMoyen: 'avg. no click',
    patrouille: 'patrol',
    veille: 'standby',
    total: 'total',
    fondDeCarte: 'standby · base map',
    aucuneSortiePlanifiee: 'no outings scheduled',
    horsCarte: '{n} off the map',
    metropoles: '{n} cities',
    enPatrouille: 'on patrol',
    enVeille: 'on standby',
    metrosAide: '{recues} received, {attendues} pending, out of {total}',
    terrain: 'field',
    sansClic: 'no click',
    syntheseEtudes: 'research synthesis',
    oui: 'yes',
    enCours: 'in progress',
    aucune: 'none',
    marquesRattachees: 'linked brands',
    sousTerritoires: 'observed sub-territories',
    ouvrirFiche: 'open details',
    horsCatalogueAucun: 'not catalogued: no territory',
    metropolesAria: 'Cities on patrol',
    national: 'national',
    horsCatalogue: 'not catalogued',
    aTraiter: 'action needed',
    triAide: 'Divergences by age, then saturations by intensity, then new topics.',
    tri: 'oldest first',
    aucuneAlerte: 'no alerts on the observed day',
    attenteDigest: 'waiting for the digest',
    aucuneAlerteMaisNeufs: 'no alerts: here is what is moving',
    jPlus: 'D+{n}',
    alerte: {
      divergence: 'field ≠ research · {sujet}',
      saturation: 'saturation · outings with no click',
      saturationDetail: '{n}% of outings catch nothing: reduce the scouts or revise the synthesis.',
      neuf: 'new topic · “{sujet}”',
      neufDetail: '{n} topics appeared on {jour}. | {n} topic appeared on {jour}. | {n} topics appeared on {jour}.',
      dernierJour: 'the last observed day',
    },
    legende: {
      recu: 'received',
      sature: 'saturated ≥ {seuil}%',
      attendu: 'pending',
      neuf: 'new topic',
      vide: 'nothing found',
      jn: 'D+n',
      divergence: 'field≠research',
      veille: 'not observed',
      fond: 'on standby',
    },
    verticales: 'verticals',
    domaines: '{n} domains · no coordinates',
    barre: 'bar = no-click share',
    tuileAttendue: '{nom}: session not returned',
    tuile: '{nom}: {sorties} outings, {sansClic} | {nom}: {sorties} outing, {sansClic} | {nom}: {sorties} outings, {sansClic}',
    pctSansClic: '{n}% no click',
    echelles: {
      country: '{n} countries | {n} country | {n} countries',
      region: '{n} regions | {n} region | {n} regions',
      continent: '{n} continents | {n} continent | {n} continents',
      city: '{n} cities | {n} city | {n} cities',
      autre: '{n} others | {n} other | {n} others',
    },
  },
}
